import React, { useState, useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import {
  Container,
  Typography,
  Paper,
  CircularProgress,
} from "@material-ui/core";
import { Alert } from "@material-ui/lab";
import VenuesTable from "./VenuesTable";
import VenuesService from "../../services/VenuesService";

const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(3),
  },
  title: {
    marginBottom: theme.spacing(3),
  },
  paper: {
    padding: theme.spacing(2),
  },
  loading: {
    display: "flex",
    justifyContent: "center",
    padding: theme.spacing(3),
  },
}));

const SuperAdminPage = () => {
  const classes = useStyles();
  const [venues, setVenues] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchVenues = async () => {
      try {
        setLoading(true);
        const data = await VenuesService.getVenues();
        setVenues(data);
        setError(null);
      } catch (err) {
        console.error("Error fetching venues:", err);
        setError("Failed to load venues. Please try again.");
      } finally {
        setLoading(false);
      }
    };

    fetchVenues();
  }, []);

  if (loading) {
    return (
      <Container className={classes.root}>
        <div className={classes.loading}>
          <CircularProgress />
        </div>
      </Container>
    );
  }

  return (
    <Container className={classes.root}>
      <Typography variant="h4" className={classes.title}>
        Super Admin - Venues
      </Typography>
      
      {error && (
        <Alert severity="error" style={{ marginBottom: 16 }}>
          {error}
        </Alert>
      )}

      <Paper className={classes.paper}>
        <VenuesTable venues={venues} />
      </Paper>
    </Container>
  );
};

export default SuperAdminPage; 